import { render } from "./DestinationBox.vue?vue&type=template&id=ab4275fc&scoped=true"
import script from "./DestinationBox.vue?vue&type=script&lang=js"
export * from "./DestinationBox.vue?vue&type=script&lang=js"

import "./DestinationBox.vue?vue&type=style&index=0&id=ab4275fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4275fc"]])

export default __exports__